customElements.get("load-more") || customElements.define("load-more", class extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector("a"), this.buttonText = this.button.textContent, 
    this.section = this.dataset.section || "", this.selectors = [ "[data-grid]", "[data-pagination-next]", "[data-pagination-previous]" ], 
    this.per_page = this.dataset.perPage || null, window.addEventListener("popstate", this.scrollUp.bind(this));
  }
  connectedCallback() {
    this.button?.addEventListener("click", this.loadMore.bind(this));
  }
  loadMore(t) {
    t.preventDefault(), t.stopPropagation(), this.classList.add("opacity-50", "cursor-wait"), 
    window.strings.loading && (this.button.textContent = window.strings.loading);
    const e = t.target.dataset.mode?.includes("prev") ? "afterbegin" : "beforeend", s = document.querySelector(`#shopify-section-${this.section}`) || document, o = new URL(t.target.href), n = new URLSearchParams(o.search);
    n.set("section_id", this.section), fetch(`${o.pathname}?${n.toString()}`).then(t => t.text()).then(o => {
      const r = (new DOMParser).parseFromString(o, "text/html");
      [ `[data-load-${t.target.dataset.mode || "next"}]`, ...this.selectors ].forEach(o => {
        const a = s.querySelector(o);
        if (a) {
          const t = r.querySelector(o);
          t ? o.toLowerCase().includes("grid") ? a.insertAdjacentHTML(e, t.innerHTML) : a.replaceWith(t) : a.parentNode.removeChild(a);
        }
        history.pushState(Object.fromEntries(n), "", t.target.href), this.button.textContent = this.buttonText;
      });
    }).catch(e => {
      console.warn(e), location.href = t.target.href;
    }).finally(() => {
      this.classList.remove("opacity-50", "cursor-wait");
    });
  }
  scrollUp() {
    if (!this.selectors.length || !this.per_page) return;
    const t = new URLSearchParams(window.location.search), e = parseInt(t.get("page")) || 1, s = document.querySelector(this.selectors[0]).children[(e - 1) * this.per_page] || !1;
    s && s.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
});